/* eslint-disable internal-rules/no-restricted-design-system-props */
/* eslint-disable internal-rules/no-restricted-design-system-imports */
import type { ComponentProps, ForwardedRef, JSX } from 'react';

import { Image } from '@change/ds-core-ui';

import { forwardRef } from '@change-corgi/core/react/core';

import { useQRCode } from 'src/app/shared/hooks/qrcode';

type ImageProps = ComponentProps<typeof Image>;
type QRCodeProps = { value: string; includeMargin?: boolean; size?: number } & ImageProps;
function QRCodeInner(
	{ value, includeMargin = true, size = 80, ...rest }: QRCodeProps,
	ref: ForwardedRef<HTMLImageElement>,
): JSX.Element | null {
	const { data } = useQRCode({ value, size, includeMargin });

	if (!data) return null;

	return <Image src={data} aspectRatio="1:1" className="h-20 min-h-20 w-20 min-w-20" alt="" {...rest} ref={ref} />;
}

export const QRCode = forwardRef(QRCodeInner);
